export default __webpack_public_path__ + "static/media/branch-icon-black.4e868e4e.svg";